/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { memo } from 'react';

import { CIColors } from 'shared';

import { determineNodeStatusColor } from '../../../../../utils/determineNodeStatusColor';
import { NodeStatus } from '../../NodeStatus';
import { NetworkNode } from '../NodesNetwork.types';

type NodesNetworkTooltipProps = {
  label: string;
  status: NodeStatus;
  type: NetworkNode['type'];
};

export const NodesNetworkTooltip = memo<NodesNetworkTooltipProps>(({ label, status, type }) => {
  return (
    <div
      style={{
        background: 'white',
        padding: '8px 12px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        minWidth: 120,
        wordWrap: 'break-word',
        color: CIColors.Text,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {type !== 'add' && (
        <div
          style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: determineNodeStatusColor(status),
            marginRight: '5px',
          }}
        />
      )}
      <strong>{label}</strong>
    </div>
  );
});
